import React from 'react';
import PropTypes from 'prop-types';

const Summary = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 14.25V7.875C15 7.75857 14.9729 7.64373 14.9208 7.53959C14.8687 7.43545 14.7931 7.34486 14.7 7.275L9.45 3.3375C9.32018 3.24013 9.16228 3.1875 9 3.1875C8.83772 3.1875 8.67982 3.24013 8.55 3.3375L3.3 7.275C3.20685 7.34486 3.13125 7.43545 3.07918 7.53959C3.02711 7.64373 3 7.75857 3 7.875V14.25C3 14.4489 3.07902 14.6397 3.21967 14.7803C3.36032 14.921 3.55109 15 3.75 15H6.75C6.94891 15 7.13968 14.921 7.28033 14.7803C7.42098 14.6397 7.5 14.4489 7.5 14.25V12C7.5 11.8011 7.57902 11.6103 7.71967 11.4697C7.86032 11.329 8.05109 11.25 8.25 11.25H9.75C9.94891 11.25 10.1397 11.329 10.2803 11.4697C10.421 11.6103 10.5 11.8011 10.5 12V14.25C10.5 14.4489 10.579 14.6397 10.7197 14.7803C10.8603 14.921 11.0511 15 11.25 15H14.25C14.4489 15 14.6397 14.921 14.7803 14.7803C14.921 14.6397 15 14.4489 15 14.25Z"
      stroke={fill || '#6B6C7B'}
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Summary.propTypes = {
  fill: PropTypes.string,
};

export default Summary;
